import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import axios from 'axios';
import utils from './utils';

import 'vant/lib/index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import '/static/css/style.css';
import '/static/css/common.css';
import filters from '../static/js/filters';

for (let key in filters) {
  Vue.filter(key, filters[key]);
}

Vue.config.productionTip = false;

Vue.prototype.$baseUrl = Vue.$baseUrl = process.env.VUE_APP_API_ROOT;

Vue.prototype.utils = Vue.utils = utils;
Vue.prototype.axios = axios;

//指令--给浏览器添加固定title
Vue.directive('title', {
  inserted: function (el, binding) {
    window.document.title = el.dataset.title;
  }
});
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
